import { render } from "./AvatarNumber.vue?vue&type=template&id=6fb71fd4"
import script from "./AvatarNumber.vue?vue&type=script&lang=js"
export * from "./AvatarNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__